/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WindowsLoginRouteImport } from './routes/windows-login'
import { Route as SelectStoreRouteImport } from './routes/select-store'
import { Route as SelectRegisterRouteImport } from './routes/select-register'
import { Route as PosRouteImport } from './routes/pos'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DriverRouteImport } from './routes/driver'
import { Route as DeliveriesRouteImport } from './routes/deliveries'
import { Route as CustomerRouteImport } from './routes/customer'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PosIndexRouteImport } from './routes/pos/index'

const WindowsLoginRoute = WindowsLoginRouteImport.update({
  id: '/windows-login',
  path: '/windows-login',
  getParentRoute: () => rootRouteImport,
} as any)
const SelectStoreRoute = SelectStoreRouteImport.update({
  id: '/select-store',
  path: '/select-store',
  getParentRoute: () => rootRouteImport,
} as any)
const SelectRegisterRoute = SelectRegisterRouteImport.update({
  id: '/select-register',
  path: '/select-register',
  getParentRoute: () => rootRouteImport,
} as any)
const PosRoute = PosRouteImport.update({
  id: '/pos',
  path: '/pos',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DriverRoute = DriverRouteImport.update({
  id: '/driver',
  path: '/driver',
  getParentRoute: () => rootRouteImport,
} as any)
const DeliveriesRoute = DeliveriesRouteImport.update({
  id: '/deliveries',
  path: '/deliveries',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerRoute = CustomerRouteImport.update({
  id: '/customer',
  path: '/customer',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectRoute = ConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PosIndexRoute = PosIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PosRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/connect': typeof ConnectRoute
  '/customer': typeof CustomerRoute
  '/deliveries': typeof DeliveriesRoute
  '/driver': typeof DriverRoute
  '/login': typeof LoginRoute
  '/pos': typeof PosRouteWithChildren
  '/select-register': typeof SelectRegisterRoute
  '/select-store': typeof SelectStoreRoute
  '/windows-login': typeof WindowsLoginRoute
  '/pos/': typeof PosIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/connect': typeof ConnectRoute
  '/customer': typeof CustomerRoute
  '/deliveries': typeof DeliveriesRoute
  '/driver': typeof DriverRoute
  '/login': typeof LoginRoute
  '/select-register': typeof SelectRegisterRoute
  '/select-store': typeof SelectStoreRoute
  '/windows-login': typeof WindowsLoginRoute
  '/pos': typeof PosIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/connect': typeof ConnectRoute
  '/customer': typeof CustomerRoute
  '/deliveries': typeof DeliveriesRoute
  '/driver': typeof DriverRoute
  '/login': typeof LoginRoute
  '/pos': typeof PosRouteWithChildren
  '/select-register': typeof SelectRegisterRoute
  '/select-store': typeof SelectStoreRoute
  '/windows-login': typeof WindowsLoginRoute
  '/pos/': typeof PosIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/connect'
    | '/customer'
    | '/deliveries'
    | '/driver'
    | '/login'
    | '/pos'
    | '/select-register'
    | '/select-store'
    | '/windows-login'
    | '/pos/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/connect'
    | '/customer'
    | '/deliveries'
    | '/driver'
    | '/login'
    | '/select-register'
    | '/select-store'
    | '/windows-login'
    | '/pos'
  id:
    | '__root__'
    | '/'
    | '/auth'
    | '/connect'
    | '/customer'
    | '/deliveries'
    | '/driver'
    | '/login'
    | '/pos'
    | '/select-register'
    | '/select-store'
    | '/windows-login'
    | '/pos/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRoute
  ConnectRoute: typeof ConnectRoute
  CustomerRoute: typeof CustomerRoute
  DeliveriesRoute: typeof DeliveriesRoute
  DriverRoute: typeof DriverRoute
  LoginRoute: typeof LoginRoute
  PosRoute: typeof PosRouteWithChildren
  SelectRegisterRoute: typeof SelectRegisterRoute
  SelectStoreRoute: typeof SelectStoreRoute
  WindowsLoginRoute: typeof WindowsLoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/windows-login': {
      id: '/windows-login'
      path: '/windows-login'
      fullPath: '/windows-login'
      preLoaderRoute: typeof WindowsLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/select-store': {
      id: '/select-store'
      path: '/select-store'
      fullPath: '/select-store'
      preLoaderRoute: typeof SelectStoreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/select-register': {
      id: '/select-register'
      path: '/select-register'
      fullPath: '/select-register'
      preLoaderRoute: typeof SelectRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pos': {
      id: '/pos'
      path: '/pos'
      fullPath: '/pos'
      preLoaderRoute: typeof PosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/driver': {
      id: '/driver'
      path: '/driver'
      fullPath: '/driver'
      preLoaderRoute: typeof DriverRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deliveries': {
      id: '/deliveries'
      path: '/deliveries'
      fullPath: '/deliveries'
      preLoaderRoute: typeof DeliveriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer': {
      id: '/customer'
      path: '/customer'
      fullPath: '/customer'
      preLoaderRoute: typeof CustomerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pos/': {
      id: '/pos/'
      path: '/'
      fullPath: '/pos/'
      preLoaderRoute: typeof PosIndexRouteImport
      parentRoute: typeof PosRoute
    }
  }
}

interface PosRouteChildren {
  PosIndexRoute: typeof PosIndexRoute
}

const PosRouteChildren: PosRouteChildren = {
  PosIndexRoute: PosIndexRoute,
}

const PosRouteWithChildren = PosRoute._addFileChildren(PosRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRoute,
  ConnectRoute: ConnectRoute,
  CustomerRoute: CustomerRoute,
  DeliveriesRoute: DeliveriesRoute,
  DriverRoute: DriverRoute,
  LoginRoute: LoginRoute,
  PosRoute: PosRouteWithChildren,
  SelectRegisterRoute: SelectRegisterRoute,
  SelectStoreRoute: SelectStoreRoute,
  WindowsLoginRoute: WindowsLoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
